module.exports = __webpack_public_path__ + "img/gb886.prt.ce9a6b5c.jpg";